// import "./resume.css";
import "./resumetetris.css";
// import "./resumespiral.css";

function Resume() {
  return (
    <div className="resume">
      <div className="divresume  Firebase">Firebase</div>
      <div className="divresume  Socket">Socket.IO</div>
      <div className="divresume  Express">
        <p className="rotate">Express</p>
      </div>
      <div className="divresume  CSS">CSS</div>
      <div className="divresume  MongoDB">MongoDB</div>
      <div className="divresume  Node">
        <p className="rotate">Node.js</p>
      </div>
      <div className="divresume  React">React</div>
      <div className="divresume  Ntive">
        <p className="rotate">React Native</p>
      </div>
      <div className="divresume  JavaScript">JavaScript</div>
      <div className="divresume  HTML">HTML</div>
    </div>
  );
}

export default Resume;
